// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1Nzrj","right":"Footer_right__31SEY","buttons":"Footer_buttons__25Xvp"};